import styled from 'styled-components';
import { typography } from '../../../../styles/helpers';

export const ScDivider = styled.div`
  ${typography.body2regular}
  color: ${({ theme }) => theme.grayMegaLightColor};
  display: flex;
  align-items: center;

  &::before,
  &::after {
    flex: 1;
    content: '';
    padding: 0.5px;
    background-color: ${({ theme }) => theme.blackLightColor};
  }

  &::before {
    margin-right: 12px;
  }
  &::after {
    margin-left: 12px;
  }
`;
